import "./AddHolidays.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import ButtonSpinner from "../../../../Components/Spinners/ButtonSpinner";
import AddHolidaysViewModel from "./AddHolidaysViewModel";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";

const AddHolidays = () => {
  const {
    RegisterHolidays,
    AddHolidays,
    setAddHolidays,
    HolidaysNameError,
    HolidaysTypeError,
    HolidaysStartDateError,
    HolidaysEndDateError,
    FormDisabled,
    IsUpdate,
  } = AddHolidaysViewModel();

  const SchoolAddedResp = IsSchoolAdded();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-holidays-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate === true ? "Update Holidays" : "Add Holidays"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/admin/holidays`}>Holidays</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    {IsUpdate === true ? "Update Holidays" : "Add Holidays"}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Holidays Information</span>
                        </h5>
                        {!SchoolAddedResp && (
                          <div className="add-school-first-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-exclamation-triangle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <p>Please add school first!</p>
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group local-forms">
                          <label>Holidays Id</label>
                          <input
                            className="form-control"
                            type="text"
                            onChange={(e) => {
                              setAddHolidays({
                                ...AddHolidays,
                                HolidaysID: e.target.value,
                              });
                            }}
                            value={AddHolidays.HolidaysID}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group local-forms">
                          <label>
                            Holidays Name{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              HolidaysNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddHolidays({
                                ...AddHolidays,
                                HolidaysName: e.target.value,
                              });
                            }}
                            value={AddHolidays.HolidaysName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {HolidaysNameError === true ? (
                            <span className="admin-add-holidays-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Holidays name is required and cannot be less
                                than 3 characters.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-holidays-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Holidays name is required and cannot be less
                                than 3 characters.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group local-forms">
                          <label>
                            Type of Holidays{" "}
                            <span className="login-danger">*</span>
                          </label>
                          <select
                            id="exampleFormControlSelect1"
                            className={`form-control ${
                              HolidaysTypeError === true && "error-message"
                            }`}
                            onChange={(e) => {
                              setAddHolidays({
                                ...AddHolidays,
                                HolidaysType: e.target.value,
                              });
                            }}
                            value={AddHolidays.HolidaysType}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            <option>Select Holidays</option>
                            <option value={"national holidays"}>
                              National Holidays
                            </option>
                            <option value={"provisional holidays"}>
                              Provisional Holidays
                            </option>
                            <option value={"public holidays"}>
                              Public Holidays
                            </option>
                            <option value={"school holidays"}>
                              School Holidays
                            </option>
                            <option value={"exam holidays"}>
                              Exam Holidays
                            </option>
                            <option value={"others"}>Others</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group local-forms">
                          <label>
                            Start Date <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              HolidaysStartDateError === true && "error-message"
                            }`}
                            type="date"
                            onChange={(e) => {
                              setAddHolidays({
                                ...AddHolidays,
                                HolidaysStartDate: e.target.value,
                              });
                            }}
                            value={AddHolidays.HolidaysStartDate}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {HolidaysStartDateError === true ? (
                            <span className="admin-add-holidays-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Holidays start date is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-holidays-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Holidays start date is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-6">
                        <div className="form-group local-forms">
                          <label>
                            End Date <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              HolidaysEndDateError === true && "error-message"
                            }`}
                            type="date"
                            onChange={(e) => {
                              setAddHolidays({
                                ...AddHolidays,
                                HolidaysEndDate: e.target.value,
                              });
                            }}
                            value={AddHolidays.HolidaysEndDate}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {HolidaysEndDateError === true ? (
                            <span className="admin-add-holidays-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Holidays end date is required.
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-holidays-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Holidays end date is required.
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          onClick={(e) => {
                            e.preventDefault();
                            RegisterHolidays();
                          }}
                          disabled={FormDisabled || !SchoolAddedResp}
                        >
                          {FormDisabled && <ButtonSpinner />}{" "}
                          {IsUpdate === true ? "Update " : "Submit"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddHolidays;
